import currencyCodes from 'currency-codes';

export interface CurrencyOption {
  value: string;
  label: string;
}

/**
 * Get currency options formatted for Select component
 * Returns ISO 4217 currency codes with currency names
 */
export function getCurrencyOptions(): CurrencyOption[] {
  return currencyCodes
    .codes()
    .map((code) => {
      const currency = currencyCodes.code(code);
      if (!currency) return null;
      return {
        value: code,
        label: `${code} - ${currency.currency}`,
      };
    })
    .filter((option): option is CurrencyOption => option !== null)
    .toSorted((a, b) => a.value.localeCompare(b.value));
}

/**
 * Get a currency option by ISO 4217 code
 */
export function getCurrencyOption(code: string): CurrencyOption | undefined {
  const currency = currencyCodes.code(code);
  if (!currency) return;
  return {
    value: code,
    label: `${code} - ${currency.currency}`,
  };
}
